import { render } from "./SmIconCloneComponent.vue?vue&type=template&id=475f9f3f"
import script from "./SmIconCloneComponent.vue?vue&type=script&lang=js"
export * from "./SmIconCloneComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmIconCloneComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "475f9f3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('475f9f3f', __exports__)) {
    api.reload('475f9f3f', __exports__)
  }
  
  module.hot.accept("./SmIconCloneComponent.vue?vue&type=template&id=475f9f3f", () => {
    api.rerender('475f9f3f', render)
  })

}


export default __exports__